module.exports = {
      id: "line-arrow-next-usage",
      viewBox: "0 0 28 28",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#line-arrow-next",
      toString: function () {
        return this.url;
      }
    }